import { DataObject, RequiredField } from "../types/general";

export const getCurrentTime = () => {
    return Date.now();
}

export const formatTimestamp = (timestamp: string) => {
    if (!timestamp) return 'N/A';
    
    try {
        const date = new Date(parseInt(timestamp));
        
        if (isNaN(date.getTime())) {
            return 'Invalid Date';
        }
        
        return date.toLocaleString('en-US', {
            year: 'numeric',
            month: 'short',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
            timeZoneName: 'short'
        });
    } catch (error) {
        return 'Error formatting date';
    }
};

export const containsHtml = (text: string): boolean => {
    if (!text || typeof text !== 'string') {
        return false;
    }
    const htmlTagRegex = /<[^>]+>/;
    return htmlTagRegex.test(text);
};

export const convertUrlsToLinks = (text: string): string => {
    if (!text || typeof text !== 'string') {
        return text;
    }

    if (containsHtml(text)) {
        return text;
    }

    const urlRegex = /(https?:\/\/[^\s<>"{}|\\^`[\]]+|ftp:\/\/[^\s<>"{}|\\^`[\]]+|www\.[^\s<>"{}|\\^`[\]]+)/gi;
    
    return text.replace(urlRegex, (url) => {
        let href = url;
        if (url.toLowerCase().startsWith('www.')) {
            href = `https://${url}`;
        }
        
        return `<a href="${href}" target="_blank" rel="noopener noreferrer">${url}</a>`;
    });
};

export const isLongerArray = (value: any) => {
    return Array.isArray(value) && value.length > 1
}

export function capitalizeFirstLetter(str: string): string {
  if (!str) {
    return str;
  }
  return str.charAt(0).toUpperCase() + str.slice(1);
}

export function downloadJsonData(filename: string, jsonObject:any) {
    const jsonString = JSON.stringify(jsonObject, null, 2);
    const blob = new Blob([jsonString], { type: 'application/json' });
    const href = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = href;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(href);
  }



export const checkIfNull = (data: DataObject, field: string, missingFields: string[]) => {
    if (!data.hasOwnProperty(field) || !data[field]) {
        missingFields.push(field)
    } else if (Array.isArray(data[field]) && data[field].length < 1) {
        missingFields.push(field)
    }
}

export const getMissingFields = (data: DataObject, fields: RequiredField[]) => {
    let missingFields: string[] = [];
    fields.forEach((field) => {
        if (typeof field == 'string') {
            checkIfNull(data, field, missingFields)
        } else {
        if (field?.mainKey && field?.subKeys) {
            field.subKeys.forEach(subKey => {
                field.mainKey && data[field.mainKey]?.forEach((item: DataObject) => {
                    checkIfNull(item, subKey, missingFields)
                })
            })
        }
        }
    })
    return missingFields
}